












import { listFactory } from '@/main/pages';
// eslint-disable-next-line no-unused-vars
import { columnsToCamelCase, Row } from '@/main/utils/table';
import { objectToCamelCaseShallow } from '@/main/utils/stringHelper';

import { apiProvider } from './api';
import { store } from './store/obratList';
import { OBRAT_TYPE, OBRAT_FILTER, OBRAT } from './constants';

export default listFactory(OBRAT, store).extend({
	props: {
		type: { type: String, default: undefined },
	},
	methods: {
		async schema() {
			let resp;

			switch (this.type) {
				case OBRAT_TYPE.MATERIAL: resp = await apiProvider.obratMatSchema(); break;
				case OBRAT_TYPE.SLUZBY: resp = await apiProvider.obratSluzSchema(); break;
				default: resp = await apiProvider.obratCelkSchema(); break;
			}

			this.table.columns = columnsToCamelCase(resp.data.Columns);
		},
		async tableData() {
			let resp;

			switch (this.type) {
				case OBRAT_TYPE.MATERIAL: resp = await apiProvider.obratMatRows(this.filter); break;
				case OBRAT_TYPE.SLUZBY: resp = await apiProvider.obratSluzRows(this.filter); break;
				default: resp = await apiProvider.obratCelkRows(this.filter); break;
			}

			this.table.rows = resp.data.map((row: Row) => objectToCamelCaseShallow(row));
			return resp;
		},
		async loadFilter() {
			const { data } = await this.$store.dispatch(`${this.storeUri}/${OBRAT_FILTER}`, this.isSelectList);

			return data;
		},
	},
});
